import { APP_VERSION } from "../lib/appVersion";

export function AppVersionFooter() {
  return (
    <footer
      className="pointer-events-none fixed inset-x-0 bottom-2 z-10 text-center text-[10px] tabular-nums text-slate-600/90"
      aria-label={`App version ${APP_VERSION}`}
    >
      v{APP_VERSION}
    </footer>
  );
}
